// extracted by mini-css-extract-plugin
module.exports = {"tag":"PostTags-module--tag--2s29v"};